import { useEffect } from 'react'


/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { Grid } from '@mui/material';

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end

const PieChartExpenses = ({ keyId, year, title, data, sTypeChart }) => {

    useEffect(() => {

        // Create chart instance
        let hasValue = data.findIndex(f => f.nValue !== 0) !== -1;
        let chart = am4core.create(`chart-${sTypeChart}-${keyId}`, am4charts.PieChart3D) as any;
        let titleChart = chart.titles.create();
        titleChart.text = title;
        titleChart.fontSize = "1.2rem";
        titleChart.fontWeight = "bold";

        if (hasValue) {

            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            chart.data = data;
            chart.innerRadius = 50;
            chart.radius = am4core.percent(70);

            let series = chart.series.push(new am4charts.PieSeries3D());
            series.dataFields.value = "nValue";
            series.dataFields.category = "sName";
            series.labels.template.text = "{sName}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{sName}: {value} ({value.percent.formatNumber('#.00')}%)";

            //Legend
            chart.legend = new am4charts.Legend() as any;
            chart.legend.valueLabels.template.disabled = true;
            chart.legend.fontSize = "1rem";
            chart.legend.paddingBottom = 20
            // chart.legend.labels.template.maxWidth = 95
            chart.legend.labels.template.maxWidth = 150;
            chart.legend.labels.template.truncate = true;
            chart.legend.labels.template.text = "{sShortName}[/]";
            chart.legend.itemContainers.template.tooltipText = "{category}"
        } else {
            chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

            let lsEmpty = [{
                "sField": "Dummy",
                "disabled": true,
                "sValue": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];
            if (data.length !== 0) {
                data.forEach(element => {
                    lsEmpty.push({
                        "sField": element.sName,
                        "disabled": false,
                        "sValue": 0,
                        "color": am4core.color("#dadada"),
                        "opacity": 0.3,
                        "strokeDasharray": "4,4",
                        "tooltip": element.sName,
                    })
                });
            }
            chart.data = lsEmpty;
            chart.radius = am4core.percent(60);
            chart.innerRadius = am4core.percent(30)

            let series = chart.series.push(new am4charts.PieSeries3D());
            series.dataFields.value = "sValue";
            series.dataFields.category = "sField";
            series.dataFields.hiddenInLegend = "disabled";
            series.labels.template.fontSize = 10;
            series.labels.template.text = "{category}: {value.percent.formatNumber('#.00')}%";
            series.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
            series.tooltip.label.wrap = true;
            series.tooltip.label.width = 300;
            series.labels.template.maxWidth = 180;
            series.labels.template.wrap = true;


            /* Set tup slice appearance */
            let slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";

            /* This creates initial animation */
            series.hiddenState.properties.opacity = 1;
            series.hiddenState.properties.endAngle = -90;
            series.hiddenState.properties.startAngle = -90;

            //Legend
            chart.legend = new am4charts.Legend();
            chart.legend.valueLabels.template.disabled = true;
            chart.legend.fontSize = "1rem";
            chart.legend.labels.template.maxWidth = 100;
            chart.legend.labels.template.truncate = true;
            chart.legend.labels.template.fullWords = true;

            // Set custom ellipsis as default one is not displayed correctly
            chart.legend.labels.template.ellipsis = "...";
        }

        // Cleanup on component unmount
        return () => {
            chart.dispose();
        };
    }, [data, keyId, sTypeChart, title])

    return (
        <Grid item xs={12} pt={3}>
            <div id={`chart-${sTypeChart}-${keyId}`} style={{ width: "100%", height: "450px" }}></div>
        </Grid>
    )
}

export default PieChartExpenses;